import * as React from "react"
import {Form} from "../../../lib/sbhtml/form";
import {Input} from "../../../lib/sbhtml/input";
import {centeredModalProps, Modal} from "../../../lib/sbhtml/modal";
import {
	CategoryManager, CategoryManagerCallbackProps,
	CategoryManagerValueProps
} from "../../../lib/category-manager/presentation";
import {ErrorField} from "./data";

export type QueryFormProps = ValueProps & CallbackProps

export type ValueProps = {
	title: string
	submitting: boolean
	errorFields?: ErrorField[]
	categoryManagerValueProps: CategoryManagerValueProps
}

export type CallbackProps = {
	setTitle: (title: string) => void
	setSubmitting: (submitting: boolean) => void
	onSave: () => void
	onCancel: () => void
	categoryManagerCallbackProps: CategoryManagerCallbackProps
}

export const QueryForm = (props: QueryFormProps) => {
	const titleErrors = props.errorFields !== undefined ? props.errorFields.filter((e) => e.fieldType == 'title') : []
	return <Form
		hasSave={true}
		onSubmit={props.onSave}
		hasCancel={true}
		onCancel={props.onCancel}
		isSubmitting={props.submitting}
	>
		<label>
			<p>Title: </p>
			<Input style={{width: "95%"}} value={props.title} onChange={props.setTitle} invalid={titleErrors.length > 0}/>
			{titleErrors.length > 0 &&
			<ul>{titleErrors.map((e: ErrorField) => <li key={`error-${e.fieldType}`} style={{color: "red"}}><p style={{color: "red"}}>{e.errorMessage}</p></li>)}</ul>
			}
		</label>
		{props.categoryManagerValueProps.categories.length > 0 && <label>
			<p>Categories: </p>
			<CategoryManager {...props.categoryManagerValueProps} {...props.categoryManagerCallbackProps}/>
		</label>}
	</Form>
}

export const QueryFormModal = (props: QueryFormProps) => {
	const style = centeredModalProps('400px')

	return <Modal style={style} isOpen={true} title="Edit Query" onRequestClose={props.onCancel}>
		<QueryForm {...props}/>
	</Modal>
}



// WEBPACK FOOTER //
// ./src/contacts/saved-queries/query-form/presentation.tsx